import type { ProductInfoBoxFeatureConfig } from '../../types/features/ProductInfoBoxFeatureConfig';

export const productInfoBox: ProductInfoBoxFeatureConfig = {
    showContractNumber: true,
    showCurrentInstallment: false,
    showPurchasePrice: true,
    showRemainingTerm: false,
};
